<template>
    <div>
        <div class="page">
            <CampaignList
                :initListConfig="listConfig"
                :initFilterConfig="filterConfig"
                :modalController="modalController"
            />
        </div>
        <ModalMaster :controller="modalController" />
    </div>
</template>
<script>
// mixin
import ModalMixin from "@/mixin/ModalMixin";
// component
import CampaignList from "../component/Campaign/CampaignList.vue";
// setting builder
import {
    CampaignListConfigBuilder,
    CampaignListFilterConfigBuilder
} from "@/core/Campaign/model/CampaignConfigModel.js";
import ConfigManager from "@/config/ConfigManager.js";

export default {
    name: "Privilege",
    components: {
        CampaignList
    },
    mixins: [ModalMixin],
    data: function() {
        return {
            listConfig: {},
            filterConfig: {}
        };
    },
    created: function() {
        this.initialConfig();
    },
    methods: {
        initialConfig: function() {
            var configStr = ConfigManager.getCampaignListDevApp();
            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(configStr)
                .setTop(3)
                .setCatId(9443623)
                .create();
            this.listConfig = listConfig;
            var filterConfig = new CampaignListFilterConfigBuilder().create();
            this.filterConfig = filterConfig;
        }
    }
};
</script>
